// import React, { createContext, useContext, useState, ReactNode } from 'react';

// const NameContext = createContext(null);

// export function useName() {
//     return useContext(NameContext);
// }

// export function NameProvider({ children }: { children: ReactNode }) {
//     const [selectedName, setSelectedName] = useState(null);

//     const setName = (name: any) => {
//         setSelectedName(name);
//     };

//     return (
//         <NameContext.Provider value={{ selectedName, setName } as any}>
//             {children}
//         </NameContext.Provider>
//     );
// }


import { createContext, useContext, useState,ReactNode } from 'react';
export const SelectedDataContext = createContext(null);

export function SelectedDataProvider({ children }:any) {

  const [selectedData, setSelectedData] = useState(null);

  return (
    <SelectedDataContext.Provider value={{ selectedData,setSelectedData } as any}>
      {children}
    </SelectedDataContext.Provider>
  );
} 